import { FC } from "react";
import { Section } from "views/applications-id-report/components/Section";
import { Row } from "../../../components/Row";
import { CreditRequestData } from "types/landlord/reports";
import { getFullName } from "shared/utils/get-full-name";
import moment from "moment";
import { SsnDisplay } from "shared/components/SsnDisplay";

export const CustomerInquiry: FC<{
  applicationId: string;
  applicantId: string;
  verificationId: string;
  requestData?: CreditRequestData;
  customerReferenceNumber?: string | null;
  firstName?: string;
  lastName?: string;
}> = ({
  applicationId,
  applicantId,
  verificationId,
  requestData,
  customerReferenceNumber,
  firstName,
  lastName
}) => {
  return (
    <Section sectionTitle="Customer inquiry">
      <div className="space-y-3">
        <Row
          title="Customer name"
          value={getFullName({
            firstName: firstName ?? requestData?.first_name ?? "",
            lastName: lastName ?? requestData?.last_name ?? ""
          })}
        />
        <Row
          title="Date of birth"
          value={
            requestData?.dob &&
            moment(requestData.dob).isValid() &&
            moment(requestData.dob).format("MMM DD, YYYY")
          }
        />
        <Row
          title="SSN"
          value={
            <SsnDisplay
              applicationId={applicationId}
              applicantId={applicantId}
              verificationId={verificationId}
              maskedSsn={requestData?.ssn || "--"}
            />
          }
        />
        <Row
          title="Address"
          value={
            requestData
              ? [
                  requestData.house_number,
                  requestData.street_name,
                  requestData.city,
                  requestData.state
                ]
                  .filter(Boolean) // Filter out null, undefined
                  .join(" ")
              : ""
          }
        />
        <Row
          title="Customer reference number"
          value={customerReferenceNumber}
        />
      </div>
    </Section>
  );
};
